/**
 * Spine (kernel-native: the kernel is the system of record; no coreBOS module yet).
 * What the organisation does: business processes and services. GDPR processing activities, NIS2 services and 81/08 tasks hang off it.
 * Hand-written (ADR-029 §4); links to other spines are graph edges, see src/spines.ts.
 */
export const activityDescriptor = {
    slug: 'cmp_activity',
    kind: 'document',
    label: { singular: 'Attività', plural: 'Attività' },
    table: 'compliance_activity',
    idStrategy: 'sha256',
    fields: [
        { name: 'name', type: 'text', label: 'Nome', required: true },
        { name: 'kind', type: 'text', label: 'Tipo' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'critical_service', type: 'boolean', label: 'Servizio essenziale (NIS2)' },
    ],
    relations: [
        { name: 'organisation', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'owner_unit', kind: 'belongsTo', target: 'cmp_org_unit' },
    ],
    behaviors: { audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'PartitionOutlined', navGroup: 'Organizzazione' },
};
